import { styled } from '@mui/system';
import { Slider } from '@mui/material';
import { theme } from '../../lib/index';

export const StyledSlider = styled(Slider, {})({
  width: 90,
  height: 3,

  color: theme.palette.placeholdergrey,

  '& .MuiSlider-thumb': {
    marginTop: -1,
    width: 12,
    height: 12,

    background: theme.palette.newSecondary,
  },
});
